import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ColDef, ColumnApi, GridApi } from 'ag-grid-enterprise';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';
import { AllocationService } from 'src/app/_services/resource-allocation/allocation.service';
import { ItvendorService } from '../../../../_services/itvendor/itvendor.service';
import { ActionItemsGridRowRendererComponent } from 'src/app/components/_shared/action-items-grid-row-renderer/action-items-grid-row-renderer.component';

@Component({
  selector: 'app-vendor',
  templateUrl: './vendor.component.html',
  styleUrls: ['./vendor.component.scss']
})
export class VendorComponent implements OnInit {
  vendorForm
  rowData: any;
  public columnDefs: ColDef[]; 
  modeAction:number = 1 //1 - create // 2 - update
  // gridApi and columnApi  
  private api: GridApi;  
  private columnApi: ColumnApi;  
   defaultColDef:any;
   rowSelection:any
  tenantId: string;
  currentUser: any;
  selectedFile: File;
  form: FormGroup;
  sampleGridFrameworkComponents: any;
  gridLength = 0;
  selectedCheckboxData = []
  deleteConfirmationMsg = 'Are you sure you want to delete'

  constructor(
    private storageService: LocalStorageService,
    private formBuilder: FormBuilder,
    private itvendorService: ItvendorService,
    private allocationService: AllocationService,
  ) { 
    this.defaultColDef = {
      flex: 1,
      minWidth: 100,
      resizable: true,
    };
    this.rowSelection = 'multiple';
  this.columnDefs = this.createColumnDefs();  

  this.sampleGridFrameworkComponents = {
    actionRowRendererComponent: ActionItemsGridRowRendererComponent
  };

  this.form = this.formBuilder.group({
    file: ['', Validators.required]
  });

  this.vendorForm = new FormGroup({
    id : new FormControl(''),
    supplierName :  new FormControl('', [ Validators.required, Validators.pattern('^[a-zA-Z ]*$') ]),
    address :  new FormControl(''),
    telephoneNo :  new FormControl('', Validators.compose([ Validators.required, Validators.maxLength(12), Validators.minLength(10), Validators.pattern('^[0-9 ]*$') ])),
    contactName :  new FormControl('', Validators.required),
    legelEntityStatus :  new FormControl('', Validators.required),
    status :  new FormControl('', Validators.required),
    itemsSupplied :  new FormControl('', Validators.required),
    remark :  new FormControl(''),
  })
  
  }

  // getter for easy access to form fields
  get f() {
    return this.vendorForm.controls;
  }

  ngOnInit(): void {
    this.tenantId = this.storageService.get('tenantId');
    this.currentUser = JSON.parse(this.storageService.get('currentUser'));
    this.getVendorData();
  }

  getVendorData(){
    this.itvendorService.getAllVendors().subscribe((response: any) => {
      this.rowData = response.result;
      
    });
  }

    // one grid initialisation, grap the APIs and auto resize the columns to fit the available space  
    onGridReady(params): void {
      this.api = params.api;
      console.log('qqqq', this.api)
      this.columnApi = params.columnApi;
      this.api.sizeColumnsToFit();
    }  

      // create column definitions  
   private createColumnDefs() {
    return [
    {
      headerName: 'Supplier Name',
      field: 'supplierName',
      filter: true,
      editable: false,
      sortable: true,
      headerCheckboxSelection: this.isFirstColumn,
      checkboxSelection: this.isFirstColumn,
    },
    {
      headerName: 'Address',
      field: 'address',
      filter: true,
      editable: false,
      sortable: true
    },
    {
      headerName: 'Telephone No',
      field: 'telephoneNo',
      filter: true,
      editable: false,
      sortable: true
    },
    {
      headerName: 'Contact Name',
      field: 'contactName',
      filter: true,
      editable: false,
      sortable: true
    },
    {
      headerName: 'Legel Entity Status',
      field: 'legelEntityStatus',
      filter: true,
      editable: false,
      sortable: true
    },
    {
      headerName: 'Status',
      field: 'status',
      filter: true,
      editable: false,
      sortable: true
    },
    {
      headerName: 'Items Supplied',
      field: 'itemsSupplied',
      filter: true,
      editable: false,
      sortable: true
    },
    {
      headerName: 'Remark',
      field: 'remark',
      filter: true,
      editable: false,
      sortable: true
    },
  ]
  }

  onSelectionChanged(event) {
    this.selectedCheckboxData = []
    let select = event.api.getSelectedNodes();
    for (let item of select) {
      this.selectedCheckboxData.push(item.data)
    }
  }

  isFirstColumn(params) {
    const displayedColumns = params.columnApi.getAllDisplayedColumns();
    const thisIsFirstColumn = displayedColumns[0] === params.column;
    return thisIsFirstColumn;
  }

  createVendor() {
    let details = {
      supplierName : this.vendorForm.get('supplierName').value,
      address : this.vendorForm.get('address').value,
      telephoneNo : this.vendorForm.get('telephoneNo').value,
      contactName : this.vendorForm.get('contactName').value,
      legelEntityStatus : this.vendorForm.get('legelEntityStatus').value,
      status : this.vendorForm.get('status').value,
      itemsSupplied : this.vendorForm.get('itemsSupplied').value,
      remark : this.vendorForm.get('remark').value,
    }
    this.itvendorService.createvendors(details).subscribe(response => {
      console.log("response: ", response);
      
      // update grid after creating new lead & close the modal
      this.api.applyTransaction({ add: [response] });
      $('#closeCreateModal').trigger("click");
    });
  }

  performGridActionItem(params) {
    if (params.event.currentTarget.value == 'delete') {
      this.deleteGridRow(params);
    }     
  }

  private deleteGridRow(params: any) {
    this.itvendorService.deleteVendors(params.params.data.id).subscribe(() => {
      var selectedData = params.params.data;
      this.api.applyTransaction({ remove: [selectedData] });
    });
  }

  editOpenModal() {
    this.modeAction = 2;
    this.vendorForm.patchValue(this.selectedCheckboxData[0])
  }

  createOpenModal() {
    this.modeAction = 1;
  }

  updateVendor() {
    this.itvendorService.updateVendors(this.vendorForm.value, this.selectedCheckboxData[0].id).subscribe(res => {
      this.getVendorData();
      this.selectedCheckboxData = []
      $('#closeCreateModal').click()
    })
  }

  deleteOpenModal() {
    this.deleteConfirmationMsg = 'Are you sure you want to delete'
    for (let i in this.selectedCheckboxData) {
      if (+i === 0) this.deleteConfirmationMsg += ` ${this.selectedCheckboxData[i].supplierName}`;
      else if (this.selectedCheckboxData.length === +i + 1) this.deleteConfirmationMsg += ` & ${this.selectedCheckboxData[i].supplierName}`;
      else this.deleteConfirmationMsg += ` , ${this.selectedCheckboxData[i].supplierName}`;
    }
  }

  deleteVendorList() {
    this.itvendorService.deleteVendors(this.selectedCheckboxData[0].id).subscribe(() => {
      this.getVendorData();
      this.selectedCheckboxData = []
      $('#closeModalDeleteVendor').click()
    });
  }

}
